import { NgModule } from 'angular-ts-decorators';
import TippyAngular from 'tippy-angularjs';

import { DesignModule } from 'src/Foundation/Design/platform';

import { ProductComparisonCellComponent } from './product-comparison-cell/product-comparison-cell.component';
import { ProductComparisonInProductPageComponent } from './product-comparison-in-product-page/product-comparison-in-product-page.component';
import { ProductComparisonProductSelectorComponent } from './product-comparison-product-selector/product-comparison-product-selector.component';
import { ProductComparisonProductComponent } from './product-comparison-product/product-comparison-product.component';
import { ProductComparisonRowComponent } from './product-comparison-row/product-comparison-row.component';
import { ProductComparisonSectionComponent } from './product-comparison-section/product-comparison-section.component';
import { ProductComparisonToolbarComponent } from './product-comparison-toolbar/product-comparison-toolbar.component';
import { ProductComparisonComponent } from './product-comparison/product-comparison.component';

import { ProductDifferencesToggleComponent } from './product-differences-toggle/product-differences-toggle.component';

import { CompareBasketButtonsComponent } from './compare-basket-buttons/compare-basket-buttons.component';
import { CompareBasketProductComponent } from './compare-basket-product/compare-basket-product.component';
import { CompareBasketTogglerComponent } from './compare-basket-toggler/compare-basket-toggler.component';
import { CompareBasketComponent } from './compare-basket/compare-basket.component';

import { CompareBasketMessageDirective } from './directives/compare-basket-message.directive';
import { CompareBasketPositionDirective } from './directives/compare-basket-position.directive';

import { ProductDifferencesToggleService } from './services/product-differences.service';

@NgModule({
  declarations: [
    CompareBasketButtonsComponent,
    CompareBasketProductComponent,
    CompareBasketTogglerComponent,
    CompareBasketComponent,

    CompareBasketMessageDirective,
    CompareBasketPositionDirective,

    ProductComparisonCellComponent,
    ProductComparisonInProductPageComponent,
    ProductComparisonProductSelectorComponent,
    ProductComparisonProductComponent,
    ProductComparisonRowComponent,
    ProductComparisonSectionComponent,
    ProductComparisonToolbarComponent,
    ProductComparisonComponent,

    ProductDifferencesToggleComponent
  ],
  id: 'gn.audio.public.product-comparison',
  imports: [DesignModule, TippyAngular],
  providers: [ProductDifferencesToggleService]
})
export class ProductComaprisonModule {
}
